import "./FooterWaterMark.css";

export default function FooterWatermark() {
    return (
        <div className="footer-watermark">
            <svg
                viewBox="0 0 1200 200"
                preserveAspectRatio="xMidYMid meet"
                className="watermark-svg"
            >
                <text
                    x="50%"
                    y="50%"
                    textAnchor="middle"
                    dominantBaseline="middle"
                >
                    AVIATRICKS
                </text>
            </svg>
        </div>
    );
}
